import React from 'react';
import { useParams } from 'react-router-dom';
import ServiceBlogTemplate from '../SEOFRINDLY/BlogPageTemplte';

const SERVICES = {
    'web-development': {
        title: 'Web Application',
        industry: 'Web Development'
    },
    'mobile-apps': {
        title: 'Mobile App Development',
        industry: 'Development Services'
    },
    'food-delivery': {
        title: 'Food Delivery Solutions',
        industry: 'Development Services'
    },
    'e-commerce': {
        title: 'E-commerce Development',
        industry: 'Development Services'
    },
    'custom-software': {
        title: 'Custom Software',
        industry: 'Development Services'
    },
    'hotel-booking': {
        title: 'Hotel Booking Systems',
        industry: 'Business Solutions'
    },
    'pharmacy': {
        title: 'Pharmacy Management',
        industry: 'Business Solutions'
    },
    'inventory': {
        title: 'Inventory Management',
        industry: 'Business Solutions'
    },
    'crm': {
        title: 'CRM Solutions',
        industry: 'Business Solutions'
    },
    'pos': {
        title: 'Point of Sale Systems',
        industry: 'Business Solutions'
    },
    'accounting': {
        title: 'Accounting Software',
        industry: 'Business Solutions'
    },
    'supply-chain': {
        title: 'Supply Chain Management',
        industry: 'Business Solutions'
    },
    'hrm': {
        title: 'Human Resource Management',
        industry: 'Business Solutions'
    },
    'erp': {
        title: 'Enterprise Resource Planning',
        industry: 'Business Solutions'
    },
    'appointment-booking': {
        title: 'Online Appointment Booking',
        industry: 'Business Solutions'
    },
    'fleet-management': {
        title: 'Fleet Management Systems',
        industry: 'Business Solutions'
    },
    'customer-support': {
        title: 'Customer Support Platforms',
        industry: 'Business Solutions'
    },
    'technical': {
        title: 'Technical Consultation',
        industry: 'Consulting'
    },
    'business-analysis': {
        title: 'Business Analysis',
        industry: 'Consulting'
    },
    'marketing': {
        title: 'Marketing Strategy',
        industry: 'Consulting'
    },
    'project-management': {
        title: 'Project Management',
        industry: 'Consulting'
    },
    'ui-ux': {
        title: 'UI/UX Design',
        industry: 'Design Services'
    },
    'graphic': {
        title: 'Graphic Design',
        industry: 'Design Services'
    },
    'branding': {
        title: 'Branding',
        industry: 'Design Services'
    },
    'product': {
        title: 'Product Design',
        industry: 'Design Services'
    },
    'seo': {
        title: 'SEO Optimization',
        industry: 'Marketing Services'
    },
    'content': {
        title: 'Content Marketing',
        industry: 'Marketing Services'
    },
    'ppc': {
        title: 'PPC Campaigns',
        industry: 'Marketing Services'
    },
    'social-media': {
        title: 'Social Media Management',
        industry: 'Marketing Services'
    },
    'cloud': {
        title: 'Cloud Solutions',
        industry: 'Development Services'
    },
    'digital-marketing': {
        title: 'Digital Marketing',
        industry: 'Marketing Services'
    },
    'it-consulting': {
        title: 'IT Consulting',
        industry: 'Consulting'
    }
};


const LOCATIONS = {
    'gorakhpur': 'Gorakhpur',
    'india': 'India',
    'delhi': 'Delhi',
    'patna': 'Patna',
    'faridabad': 'Faridabad',
    'punjab': 'Punjab',
    'uk': 'UK',
    'us': 'US'
};

const BlogPage = () => {
    const { location, service } = useParams();

    // Check if location and service exist in our configuration
    if (!LOCATIONS[location?.toLowerCase()] || !SERVICES[service?.toLowerCase()]) {
        return <div>404 - Page Not Found</div>;
    }

    // Generate content for the blog
    const blogContent = {
        location: LOCATIONS[location.toLowerCase()],
        service: SERVICES[service.toLowerCase()].title,
        serviceDescription: `
    Transform Your Business with Custom Solutions from Vibhraad
    
        Looking to develop a ${SERVICES[service.toLowerCase()].title} in  
        ${LOCATIONS[location.toLowerCase()]}?  
        Vibhraad specializes in crafting innovative solutions that revolutionize the way businesses engage with their customers.  
        Whether you're aiming to build a dynamic website, intuitive mobile application, or scalable e-commerce platform,  
        our team is equipped to bring your vision to life.

        We understand the importance of local market insights and tailor our services to meet the unique needs of businesses in  
        ${LOCATIONS[location.toLowerCase()]}. Our goal is to provide seamless, high-performing digital products that  
        enhance customer experiences and drive growth.
 

     Why Choose Vibhraad?

        Expertise: Years of experience in developing cutting-edge technology solutions.
        Customization: Tailored services that align with your brand and business goals.
        Local Focus: We understand your local market to deliver impactful results.

        Ready to elevate your business? Contact Vibhraad today to start your project and redefine how you connect with your audience.

`,
        processSteps: [
            {
                title: "Discovery & Planning",
                description: `We analyze your ${service.toLowerCase()} requirements and create a detailed project roadmap`
            },
            {
                title: "UI/UX Design",
                description: "Creating intuitive interfaces that delight users"
            },
            {
                title: "Development",
                description: `Building robust ${service.toLowerCase()} systems`
            },
            {
                title: "Testing & Launch",
                description: "Rigorous testing and successful market deployment"
            }
        ],

        benefits: [
            {
                title: "Local Market Expertise",
                description: `Deep understanding of ${LOCATIONS[location.toLowerCase()]}'s ecosystem`
            },
            {
                title: "Custom Solutions",
                description: "Tailored features for your specific business needs"
            },
            {
                title: "24/7 Support",
                description: "Round-the-clock technical support and maintenance"
            }
        ],
        testimonials: [
            {
                content: `Vibhraad delivered an excellent solution for our business in ${LOCATIONS[location.toLowerCase()]}.`,
                name: "Client Name",
                company: "Company Name"
            }
        ]
    };

    return <ServiceBlogTemplate {...blogContent} />;
};

export default BlogPage;